module.exports = __webpack_public_path__ + "static/businesses_1-76125b41a6237be82de1f0faa3b4b4d7.svg";